<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div id="main-container">

      <div id="algolia-content-container" class="data-list-container">

        <vs-table ref="table" class="pb-5" search pagination :max-items="itemsPerPage" :data="cyclopedias">

          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

            <vs-button color="primary" type="border" icon-after icon="add" @click="showCreateCyclopediaDialog">Add New Book/Title</vs-button>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ cyclopedias.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : cyclopedias.length }} of {{ cyclopedias.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>

                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>


          <template slot="thead">
            <vs-th sort-key="id">ID</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th>Companies</vs-th>
            <vs-th>Analyses</vs-th>
            <vs-th>Active</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody v-for="(cyclopedia, indextr) in data" :data="cyclopedia" :key="indextr" @click="goToCyclopediaDetail(cyclopedia.id)">
            <vs-tr class="cursor-pointer">

              <vs-td>
                <p class="font-medium truncate">{{ cyclopedia.id }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">{{ cyclopediaHelpers.getPreferredName(cyclopedia) }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">{{ cyclopediaHelpers.companiesString(cyclopedia) }}</p>
              </vs-td>

              <vs-td>
                <p class="font-medium truncate">{{ cyclopediaHelpers.analysesString(cyclopedia) }}</p>
              </vs-td>

              <vs-td>
                <vs-chip v-if="cyclopedia.active" color="success">Yes</vs-chip>
                <vs-chip v-if="!cyclopedia.active" color="warning">No</vs-chip>
              </vs-td>

            </vs-tr>
            </tbody>
          </template>

        </vs-table>

      </div>
    </div>

    <vs-prompt
      @accept="createCyclopedia"
      title="New Book/Title"
      :active.sync="showCreateCyclopediaDialogFlag">
      <div>

        <div class="vx-row mb-2">
          <div class="vx-col w-full">
            <vs-input
              class="w-full mb-1"
              label-placeholder="Name"
              v-model="newCyclopediaModel.name"
            />
            <vs-textarea
              class="w-full mb-1"
              label="Description"
              v-model="newCyclopediaModel.description"
            />
          </div>
        </div>

      </div>
    </vs-prompt>
<!--    <div v-html="jp.toHtml(cyclopedias)"></div>-->
  </div>
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  import jsonPrinter from '@/misc/jsonHtmlPrinter';
  import {cyclopediaHelpers} from '@/models/helpers'

  export default {
    components: {},
    data() {
      return {
        showCreateCyclopediaDialogFlag: false,
        models: models,
        isSearchStalled: false,
        currentRefinement: true,
        jp: jsonPrinter,
        cyclopediaHelpers: cyclopediaHelpers,
        newCyclopediaModel: new models.Cyclopedia(),

        isMounted: false,
        itemsPerPage: 25,

        cyclopedias: [new models.Cyclopedia()],

      }
    },
    mounted() {
      this.isMounted = true;
      this.fetchCyclopedias();
    },
    computed: {
      currentPage() {
        if(this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
    },
    watch: {
      isSearchStalled(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      async goToCyclopediaDetail(cyclopediaId) {
        this.$router.push(`/content/books/detail?id=${cyclopediaId}`).catch(() => {
        });
      },

      async fetchCyclopedias() {
        this.isSearchStalled = true;
        this.cyclopedias = await api.fetchAllCyclopedias();
        this.isSearchStalled = false;
      },
      showCreateCyclopediaDialog(cyclopedia) {
        this.newCyclopediaModel = new models.Cyclopedia(cyclopedia);
        this.showCreateCyclopediaDialogFlag = true;
      },
      async createCyclopedia() {
        if (this.newCyclopediaModel.name === '' || this.newCyclopediaModel.description === '') {
          this.showCreateCyclopediaDialog(this.newCyclopediaModel);
          this.showNotification(false, 'Both a name and description are required');
          return;
        }
        this.isSearchStalled = true;

        let newCyclopedia = await api.createNewCyclopedia(this.newCyclopediaModel);
        this.isSearchStalled = false;

        if (newCyclopedia !== null && newCyclopedia.id > 0) {
          this.goToCyclopediaDetail(newCyclopedia.id);
        } else {
          this.showNotification(false, 'Error creating book/title');
        }

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    },
  }

</script>


<style lang="scss">

</style>

